'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_DATA_INGRESO_COBRANZAS,
    RECEIVE_DATA_INGRESO_COBRANZAS,
    INITIAL_STATE_INGRESO_COBRANZAS,
    RESET_STATE_INGRESO_COBRANZAS,
    LIMPIAR_INGRESO_COBRANZAS,
    ACEPTAR_INGRESO_COBRANZAS,
    ELIMINAR_INGRESO_COBRANZAS,
    ACTUALIZAR_INGRESO_COBRANZAS,
    EDITAR_INGRESO_COBRANZAS,
    CONFIRMAR_INGRESO_COBRANZAS,
    DENEGAR_INGRESO_COBRANZAS,
    SUCCESS_INGRESO_COBRANZAS,
    LOADING_INGRESO_COBRANZAS,
    SELECCIONAR_MONEDA_INGRESO_COBRANZAS,
    EXPANDIR_ROW_INGRESO_COBRANZAS,
    CHANGE_IMPORTE_INGRESO_COBRANZAS,
    CHANGE_REFERENCIA_INGRESO_COBRANZAS,
    CHANGE_DATE_INGRESO_COBRANZAS
} from '../../Screens/IngresoCobranzas/actions/IngresoCobranzasActions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        cobranzaId: 0,
        monedaId: 0,
        importe: 0,
        fechaValor: new Date(),
        referencia: "",
        cuenta: undefined,
        cuentaTarjetaId: undefined,
        accion: "guardar",
        isLoading: true,
        cobranzas: [],
        tipoMoneda: [],
        fechaCobranza: undefined,
        rowSeleccionada: undefined,
        sucursalId: 0,
        cobranzaEstadoId: 0,
        cobranzaOrigenId: 0,
        formaPagoId: 0,
        tarjetaCreditoId: 0
    }
};

function ingresoCobranzas(state = initialState, action) {
    LogHelper.In(ingresoCobranzas.name, state, action);

    switch (action.type) {

        case INITIAL_STATE_INGRESO_COBRANZAS:
            return initialState;

        case GET_DATA_INGRESO_COBRANZAS:
            return initialState

        case RECEIVE_DATA_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                    cobranzas: action.data.cobranzas,
                    tipoMoneda: action.data.tipoMoneda,
                    monedaId: action.data.tipoMoneda[0].ID,
                    fechaCobranza: action.data.fechaCobranza,
                    sucursalId: action.data.sucursalId,
                    cobranzaEstadoId: action.data.cobranzaEstadoId,
                    cobranzaOrigenId: action.data.cobranzaOrigenId,
                    formaPagoId: action.data.formaPagoId,
                    tarjetaCreditoId: action.data.tarjetaCreditoId,
                    cuentaTarjetaId: action.data.cuentaTarjetaId,
                    isLoading: false
                },
            };

        case LIMPIAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                    monedaId: state.data.tipoMoneda[0].ID,
                    importe: 0,
                    fechaValor: new Date(),
                    referencia: "",
                    accion: "guardar"
                }            
            };

        case EXPANDIR_ROW_INGRESO_COBRANZAS:
            let id = undefined;
            if (state.data.rowSeleccionada != action.id) {
                if(state.data.rowSeleccionada == action.id){
                    id = undefined
                }
                else{
                    id = action.id
                }        
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    rowSeleccionada: id
                }
            };

        case CHANGE_REFERENCIA_INGRESO_COBRANZAS:

            return {
                ...state,
                data: {
                    ...state.data,
                    referencia: action.referencia
                }
            };

        case CHANGE_IMPORTE_INGRESO_COBRANZAS:

            return {
                ...state,
                data: {
                    ...state.data,
                    importe: action.importe
                }
            };

        case SELECCIONAR_MONEDA_INGRESO_COBRANZAS:

            return {
                ...state,
                data: {
                    ...state.data,
                    fechaValor: action.fechaValor
                }
            };

        case CHANGE_DATE_INGRESO_COBRANZAS:

            return {
                ...state,
                data: {
                    ...state.data,
                    monedaId: action.monedaId
                }
            };

        case LOADING_INGRESO_COBRANZAS:
            return {
                ...state,
                isLoading: true
            };

        case SUCCESS_INGRESO_COBRANZAS:
            return {
                ...state,
                isLoading: false
            };

        case RECEIVE_DATA_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                    cuenta: action.data.cuenta,
                    isLoading: false
                }          
            };

        case ACTUALIZAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case ELIMINAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case EDITAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                    cobranzaId: action.cobranza.Id,
                    sucursalId: action.cobranza.SucursalId,
                    monedaId: action.cobranza.CobranzaMonedaId,
                    importe: action.cobranza.CobranzaMonedaId == 1 ? action.cobranza.ImportePesos : action.cobranza.ImporteDolares,
                    fechaValor: action.cobranza.FechaValor,
                    referencia: action.cobranza.NumeroReferencia,
                }
            }

        case CONFIRMAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case DENEGAR_INGRESO_COBRANZAS:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        default:
            return state;
    }
}

export default ingresoCobranzas;